import styled, { css } from "styled-components";
import { Select } from "antd";
import { theme } from "../../styles/theme";

export const CustomSelect = styled(Select)`
  width: 100%;
  font-size: ${theme.fonts.size.default};

  &&& {
    .ant-select {
      &-selection-search-input {
        padding-left: 10px;
      }

      &-selector,
      &-selection-search-input,
      &-selection-placeholder {
        height: ${(props) => props.height || "50px"};

        &:hover {
          border: 1px solid ${theme.colors.light4} !important;
          box-shadow: initial;
          border-radius: ${(props) => props.radius || "12px"};
        }
      }
      &-selection-placeholder,
      &-selection-item {
        line-height: ${(props) => props.height || "50px"};
      }
      &-selection-placeholder {
        color: ${theme.colors.grey1};
      }
      &-selection-item {
        height: ${(props) => props.height || "50px"};
        padding-top: 1px;
        color: ${theme.colors.grey};
        text-transform: capitalize;
      }
      &-selector {
        align-items: center;
        border-color: ${theme.colors.light4};
        border-radius: ${(props) => props.radius || "12px"};
        padding-left: ${(props) => props.paddingx}px;
        padding-right: ${(props) => props.paddingx}px;
        // Adding style when search
        .ant-select-selection-search {
          left: 0;
          right: 0;
          padding-left: ${(props) => props.paddingx}px;
        }
      }
    }
    &.ant-select {
      // When focus
      &-focused:not(.ant-select-disabled) {
        &.ant-select-show-search {
          img {
            display: none;
          }
        }
        .ant-select-selector {
          outline: 0;
          border: 1px solid ${theme.colors.light4} !important;
          box-shadow: initial;
        }
      }
      // When open
      &-open {
        &:not(.ant-select-show-search) {
          .ant-select-arrow {
            transform: rotate(-180deg);
          }
        }
      }
      // When disabled
      &-disabled {
        .ant-select-selection-placeholder {
          color: ${theme.colors.grey1};
        }
      }
      // On Search
      &-show-search {
        .ant-select-selection-item {
          display: block;
          align-items: center;
        }
      }
    }
  }
`;
